// extracted by mini-css-extract-plugin
module.exports = {"pressTopSection":"PressTopSection_pressTopSection__RNmlx","content":"PressTopSection_content__vcmqu","pressCall":"PressTopSection_pressCall__RJFcn"};